import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { getSearchQueryValue } from '@client/shared/utils/urlUtils/urlUtils';
import Flex from '@client/components/flex/Flex';
import styleHelper from '@client/shared/styles/styleHelper.scss';

function LoginToClaimPage({ location }) {
  const auth = useAuth0();
  const isAuthenticated = auth && auth.isAuthenticated;
  const loginWithRedirect = auth && auth.loginWithRedirect;
  const claimingFundraiser = getSearchQueryValue(location.search, 'fundraiser');

  useEffect(() => {
    const asyncLoginWithRedirect = async () => {
      await loginWithRedirect();
    };

    if (isAuthenticated) {
      history.push(`/insamling/${claimingFundraiser}`);
    } else if (loginWithRedirect) {
      asyncLoginWithRedirect();
    }
  }, [isAuthenticated, loginWithRedirect]);

  return (
    <Flex flexNr={1} justifyCenter alignCenter>
      <p className={styleHelper.titleMdPrimary}>Du loggas nu in...</p>
    </Flex>
  );
}

LoginToClaimPage.propTypes = {
  location: PropTypes.object,
  cookies: PropTypes.object,
};

export default withCookies(LoginToClaimPage);
